import { apiGet, apiPost, apiPut } from "@/core/api";
import { DraftApplication } from "./model";

export const createDraftApplication = async (citizenId: string, applicationType: string, content: any) =>
    apiPost<string>(`citizens/${citizenId}/draftApplications/${applicationType}`, content);

export const getDraftApplication = async (citizenId: string, applicationType: string) =>
    apiGet<DraftApplication>(`citizens/${citizenId}/draftApplications/${applicationType}`);

export const updateDraftApplicationContent = async (citizenId: string, draftId: string, content: any) =>
    apiPut<DraftApplication>(`citizens/${citizenId}/draftApplications/${draftId}`, content);